
import {Component, Prop, Vue} from 'vue-property-decorator';
import {isEmpty, showError, showSuccess, showWarning} from "@/utils/Common";
import {MSG_ADD_SUCCESS, MSG_INVALID_PAGE, MSG_MODIFY_SUCCESS} from "@/configs/Consts";

import {Tooltip} from 'element-ui';

Vue.use(Tooltip);

@Component
export default class ModifyInvoice extends Vue {

    @Prop({type: Object, default: () => new Object()})
    invoiceItem!: any;

    @Prop({type: String, default: () => "invoicemanager"})
    moduleName!: string;

    isEditInvoice() {
        return this.invoiceItem && !isEmpty(this.invoiceItem.id)
    }

    saveInvoice() {
        const form = this.$refs.invoiceForm as any;
        form.validate((isValid: boolean) => {
            if (!isValid) {
                showWarning(MSG_INVALID_PAGE);
                return;
            }
            this.$store.dispatch(this.isEditInvoice() ? `${this.moduleName}/updateInvoice` : `${this.moduleName}/addInvoice`, JSON.parse(JSON.stringify(this.invoiceItem)))
                .then((id) => {
                    showSuccess(this.isEditInvoice() ? MSG_MODIFY_SUCCESS : MSG_ADD_SUCCESS);
                    this.$emit("update:invoiceItem", {});
                    this.$emit("data-success", {id: this.isEditInvoice() ? this.invoiceItem.id : id});
                })
                .catch(({message}) => showError(message));
        });
    }
}
